import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { home } from "@paths";
import { ActiveProjectStore, ActiveProjectStoreProvider } from "@stores";
import { getProjectDetailsQuery, getTeamMembersQuery } from "@query";
import { useStores } from "@hooks";
import { CircularProgress, Grid } from "@material-ui/core";
import { PageCircularProgress } from "@components";
import { ActiveProjectDetailsView } from "./ActiveProjectDetailsView";
import { ActiveProjectsSocketProvider } from "@client";

export const ActiveProjectDetails = () => {
  const { userStore } = useStores();
  const { projectUuid } = useParams();
  const navigate = useNavigate();

  const [ isLoading, setIsLoading ] = useState(true);
  const [ teamMembers, setTeamMembers ] = useState([]);

  const [ activeProjectStore ] = useState(new ActiveProjectStore());

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const details = await getProjectDetailsQuery(projectUuid);
      const users = await getTeamMembersQuery(userStore.workspaceUuid);
      activeProjectStore.addOrUpdateProject(details);
      activeProjectStore.setCurrentProject(projectUuid);
      setTeamMembers(users);
      setIsLoading(false);
    } catch (error) {
      navigate(home);
    }
  }

  return isLoading
    ? <PageCircularProgress/>
    : (
    <ActiveProjectStoreProvider value={activeProjectStore}>
      <ActiveProjectsSocketProvider>
        <Grid item container justifyContent="center" alignItems="center">
          {
            isLoading
              ? <CircularProgress
                color="primary"
                size={40}
                style={{ position: "absolute", top: "50%", marginTop: -20 }}
              />
              : <ActiveProjectDetailsView
                projectUuid={projectUuid}
                teamMembers={teamMembers}
              />
          }
        </Grid>
      </ActiveProjectsSocketProvider>
    </ActiveProjectStoreProvider>
  );
};
